<template>
  <div>
    <div class="input-group ">  
        <input type="text" class="form-control" placeholder="Search..." v-model="StockCodeInput">
        <span class="input-group-text"  @click="checkSendServer">
            <i class="bi bi-search"></i>
        </span>
    </div>
    <span v-show='loading' class="position-fixed top-0 start-50 translate-middle">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </span>
    <div v-if="shouldSearch" class="posStart overflow-auto position-relative w-75" style="max-height: 25vh;z-index: 1060;">
        <listStockCodesVue v-show='!loading && shouldSearch==true'  :StockList="StockListSearch" :PartCategory="M" @Select="selectStockCode"></listStockCodesVue>
        <div class="position-absolute top-0 end-0 zPos CanClick" @click="shouldSearch=false">
          <i class="bi bi-x-square-fill text-white fs-4"></i>

        </div>
    </div> 
  </div>
</template>

<script>
import {BaseDataService} from '../../../services/BaseData.service';
import listStockCodesVue from '../../../components/StockSearch/listStockCodes.vue';
export default {
    emits: ["Select"],
    props: { StockCode: String,Route:String},
    components: {
    listStockCodesVue
  },
    data: () => ({
    loading:true,
    shouldSearch:false,
    StockCodeInput:"",
    StockListSearch:[]
  }),
  watch:{
    StockCodeInput(){
      this.checkSendServer();
    }
  },
  mounted(){
    this.loading = false;
    if(this.StockCode){
        if(this.StockCode!=''){
            this.StockCodeInput=this.StockCode;
        }
    }
  },
  methods: { 
    checkSendServer(){
        if(this.TimerTik){
            window.clearTimeout(this.TimerTik);
        } 
        this.TimerTik =  window.setTimeout(this.sendSearch.bind(this),600);
    },
    sendSearch(){
      window.clearTimeout(this.TimerTik);
      if(this.StockCodeInput.length>3 && this.StockCode!=this.StockCodeInput){
        this.shouldSearch = true;
        this.loading = true;
        BaseDataService.searchMadeIn(this.StockCodeInput).then(x=>{
            this.StockListSearch = x.data;
            this.loading = false;
            window.clearTimeout(this.TimerTik);
        });
      }
    },
    selectStockCode(row) {
        this.shouldSearch= false;
        //Route
        row.route = this.Route
        this.$emit("Select", row);
        
    }
  }
}
</script>

<style>
.posStart{
  margin-top: 0px !important;
}
.zPos{
  z-index: 99999;
}
.CanClick{
    cursor: pointer;
}
</style>